import { render } from "./PageItem.vue?vue&type=template&id=228b0b1e&scoped=true&ts=true"
import script from "./PageItem.vue?vue&type=script&lang=ts"
export * from "./PageItem.vue?vue&type=script&lang=ts"

import "./page-item.scss?vue&type=style&index=0&id=228b0b1e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228b0b1e"]])

export default __exports__